import { Button, Tooltip, TooltipContent, TooltipTrigger } from '@folio/components';
import type { LucideIcon } from 'lucide-react';

export function SelectionAction({
  label,
  icon: Icon,
  testId,
  disabled,
  onClick,
}: {
  label: string;
  icon: LucideIcon;
  testId: string;
  disabled?: boolean;
  onClick: () => void;
}) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className="size-7 shrink-0"
          aria-label={label}
          data-testid={testId}
          disabled={disabled}
          onClick={onClick}
        >
          <Icon className="size-4" />
        </Button>
      </TooltipTrigger>
      <TooltipContent>{label}</TooltipContent>
    </Tooltip>
  );
}
